import React, { useState } from 'react';
import UIModeToggle from '../../components/btns/ToggleButtonGroup';
import AbsenceKPIDashboard from '../../components/KPIDashs/AbsenceKPI';
import LeaveDashboard from '../../components/dash/LeaveDash';
import LeaveKPIDashboard from '../../components/KPIDashs/LeaveKPI';

const AttendanceKPI = () => {
  const [uiMode, setUiMode] = useState('absence');
  const [filters, setFilters] = useState({
      type: '',
      status: '',
      department: '',
      year: new Date().getFullYear(),
      month: new Date().getMonth() + 1,
      search: ''
    });
  

  const uiOptions = [
    { value: 'absence', label: 'Absence Analytics' },
    // { value: 'leave', label: 'Vacation Analytics' },
  ];

  return (
    <div>
      <UIModeToggle 
        value={uiMode} 
        onChange={(e, newValue) => setUiMode(newValue)} 
        options={uiOptions} 
      />
      { uiMode=='absence' &&
        <AbsenceKPIDashboard/>
      }
{/* 
      { uiMode=='leave' &&
        <LeaveKPIDashboard/>
      } */}
    </div>
  );
};

export default AttendanceKPI;